import React, { useState } from 'react';
import { QlikUIContext, TemplateConfig } from 'globaleris-qlik-component';
import 'globaleris-qlik-component/dist/index.css';

import Page from '../../components/page/page';
import { useQlikContext } from '../../hooks/useQlikContext';

export const TemplateConfigurationPage = props => {

  const { isContextInitialized, context } = useQlikContext();
  const [templateId] = useState<number>(
    props.location.state ? props.location.state.idElement : 332
  );

  return (
    <Page>
      {isContextInitialized &&
        <QlikUIContext.Provider value={context}>
          {
            <TemplateConfig
              templateId={templateId}
              onEndConfiguration={() => {
                javascript: void 0;
              }}
            />
          }
        </QlikUIContext.Provider>
      }
    </Page>
  );
};
